export default __webpack_public_path__ + "static/media/vertical.ef924686.svg";